import { render, staticRenderFns } from "./UploadOneOrMultip.vue?vue&type=template&id=f47a3d1c&scoped=true"
import script from "./UploadOneOrMultip.vue?vue&type=script&lang=js"
export * from "./UploadOneOrMultip.vue?vue&type=script&lang=js"
import style0 from "./UploadOneOrMultip.vue?vue&type=style&index=0&id=f47a3d1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47a3d1c",
  null
  
)

export default component.exports